<template>
  <div
    v-if="termsAndConditions"
    class="almost-there"
  >
    <p>Almost there...</p>

    <div
      v-html="termsAndConditions"
    />
  </div>
</template>

<script>
export default {
  name: 'lg-terms-and-conditions',
  inject: ['isLeadgen', 'config'],
  computed: {
    providersQtyLabel () {
      if (this.productName === 'motorfleet') {
        return 'three';
      }

      return 'five';
    },
    termsAndConditions () {
      if (!this.isLeadgen) return;

      if (this.config.partnerTermsAndConditions === 'default') {
        return `<p>
              By clicking "Accept and get quotes" below, <br>
              I'll confirm my details with any provider before I buy a policy and I have read and agree to the Quotezone
              <a
                href="https://www.quotezone.co.uk/legal.htm?_ga=2.172352235.936333296.1627470696-2020050643.1626340149"
                target="_blank"
              >terms and conditions</a>
              and
              <a
                href="https://www.quotezone.co.uk/privacy-policy.htm?_ga=2.172352235.936333296.1627470696-2020050643.1626340149"
                target="_blank"
              >privacy policy</a>.
            </p>
            <p>
              Quotezone's clever computers will select up to ${this.providersQtyLabel} insurance providers from its panel
              (<a
                :href="https://www.quotezone.co.uk/our-lead-generation-partners.htm?_ga=2.82692574.936333296.1627470696-2020050643.1626340149#${this.productName}"
                target="_blank"
              >view list</a>)
              to share my quote details with and they, along with Quotezone, may call me by phone to discuss my quote.
            </p>
            <p>
              And finally, Quotezone will send me a handy quote summary email and may remind me via email, SMS, and telephone about my renewal.
            </p>`;
      }

      return this.config.partnerTermsAndConditions;
    },
  },
};
</script>

<style scoped lang="scss">
.almost-there {
  color: darkgrey;
  font-weight: bold;

  a {
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }

  p {
    margin: 0;

    & + p { margin-top: 1em; }
  }
}
</style>
